var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWalletActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 7.19998H4.40001V6.59998L17.6 5.54398V6.59998H19.4V4.79998C19.4 3.47998 18.3308 2.55358 17.0252 2.73958L4.97601 4.46038C3.66921 4.64758 2.60001 5.87998 2.60001 7.19998V19.2C2.60001 19.8365 2.85286 20.447 3.30295 20.897C3.75304 21.3471 4.36349 21.6 5.00001 21.6H19.4C20.0365 21.6 20.647 21.3471 21.0971 20.897C21.5471 20.447 21.8 19.8365 21.8 19.2V9.59998C21.8 8.96346 21.5471 8.35301 21.0971 7.90293C20.647 7.45284 20.0365 7.19998 19.4 7.19998ZM17.6 15.6072C17.3635 15.6071 17.1294 15.5605 16.911 15.4699C16.6926 15.3793 16.4941 15.2466 16.327 15.0794C16.1598 14.9121 16.0273 14.7136 15.9368 14.4951C15.8464 14.2766 15.7999 14.0424 15.8 13.806C15.8001 13.5695 15.8467 13.3354 15.9373 13.117C16.0279 12.8985 16.1606 12.7001 16.3278 12.5329C16.4951 12.3658 16.6936 12.2332 16.9121 12.1428C17.1306 12.0524 17.3647 12.0059 17.6012 12.006C18.0788 12.0061 18.5367 12.196 18.8742 12.5338C19.2118 12.8716 19.4014 13.3296 19.4012 13.8072C19.401 14.2847 19.2112 14.7427 18.8734 15.0802C18.5356 15.4178 18.0776 15.6073 17.6 15.6072Z",
    fill: "url(#paint0_linear_1484_9558)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1484_9558",
    x1: 1.18992,
    y1: 2.71582,
    x2: 21.482,
    y2: 21.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletActive);
export default __webpack_public_path__ + "static/media/icon_wallet_active.d3011e93c03e1d6eb582269f3b0e6c6e.svg";
export { ForwardRef as ReactComponent };